"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmeraldInputType = void 0;
var EmeraldInputType;
(function (EmeraldInputType) {
    EmeraldInputType["Date"] = "date";
    EmeraldInputType["Month"] = "month";
    EmeraldInputType["LocalTime"] = "datetime-local";
    EmeraldInputType["Week"] = "week";
    EmeraldInputType["Time"] = "time";
    EmeraldInputType["Color"] = "color";
    EmeraldInputType["Email"] = "email";
    EmeraldInputType["Number"] = "number";
    EmeraldInputType["Password"] = "password";
    EmeraldInputType["Search"] = "search";
    EmeraldInputType["PhoneNumber"] = "tel";
    EmeraldInputType["Text"] = "text";
    EmeraldInputType["TextArea"] = "textarea";
    EmeraldInputType["Url"] = "url";
})(EmeraldInputType || (exports.EmeraldInputType = EmeraldInputType = {}));
//# sourceMappingURL=input.type.js.map